const UnChecked = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 30 30"
            fill="none"
        >
            <path
                d="M10.9974 28.3307H18.9974C25.6641 28.3307 28.3307 25.6641 28.3307 18.9974V10.9974C28.3307 4.33073 25.6641 1.66406 18.9974 1.66406H10.9974C4.33073 1.66406 1.66406 4.33073 1.66406 10.9974V18.9974C1.66406 25.6641 4.33073 28.3307 10.9974 28.3307Z"
                stroke="#AAAAAA"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default UnChecked;
